import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ArrowSW.svg",
  "use": "ArrowSW.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"ArrowSW.svg\"><path d=\"M47.4018,19.3806,22.782,44H39a2,2,0,1,1,0,4H18a2,2,0,0,1-2-2V25a2,2,0,1,1,4,0V41.1551l24.6-24.6a1.9894,1.9894,0,1,1,2.8018,2.8251Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol